module.exports = __webpack_public_path__ + "static/media/powered-by-base-wide.57957628.png";